var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.774,
    height: 18.76,
    viewBox: "0 0 19.774 18.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#ffffff;stroke-linecap:round;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306.326 -232.814)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(306.326 232.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.133,
    cy: 8.133,
    r: 8.133
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8.133,
    cy: 8.133,
    r: 7.633
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4.762,
    y2: 4.762,
    transform: "translate(320.631 246.105)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.d9f96813b07a2ec32e911f0c521a55ac.svg";
export { ForwardRef as ReactComponent };